
























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Prop, Vue } from 'vue-property-decorator';
import Message from './Message.vue';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            messages: [],
        }
    },

    components: {
        Message
    },

    created() {
        this.$root.$on(`message::show::${ this.name }`, (message) => {
            this.activate(message);
        });
    },

    computed: {
        cClass() {
            let classes = ['message-bar', `message-bar--${ this.position }`];

            return classes.join(' ');
        },
    },

    methods: {
        activate(message) {
            message.showTime = (new Date()).getTime();
            this.messages.push(message);
        },

        destroy(index) {
            if (this.messages[index].showTime + this.minShowTime < (new Date()).getTime())
                this.$set(this.messages, index, null);
        },
    },

    destroyed() {
        this.$root.$off(`message::show::${ this.name }`);
    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class MessageBar extends Vue {
    @Prop({ default: 'default' }) name!: string;
    @Prop({ default: 'top' }) position!: string;
    @Prop({ default: 400 }) minShowTime!: number;
};

